import React from "react";
import SharedApplication from "../../shared/application";
import { ProfileBodyProps } from "../../types";

const Application = React.memo((props: ProfileBodyProps) => {
  if (!props.campaignId) return <></>;
  return (
    <SharedApplication
      brandId={props.brandId}
      campaignId={props.campaignId}
      user={props.user}
    />
  );
});

Application.displayName = "Application";

export default Application;
